import { render, staticRenderFns } from "./ApexTahminiKatilimci.vue?vue&type=template&id=04afecba&"
import script from "./ApexTahminiKatilimci.vue?vue&type=script&lang=js&"
export * from "./ApexTahminiKatilimci.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports